import { render, staticRenderFns } from "./Direto.vue?vue&type=template&id=e563322e&scoped=true"
import script from "./Direto.vue?vue&type=script&lang=js"
export * from "./Direto.vue?vue&type=script&lang=js"
import style0 from "./Direto.vue?vue&type=style&index=0&id=e563322e&prod&lang=css"
import style1 from "./Direto.vue?vue&type=style&index=1&id=e563322e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e563322e",
  null
  
)

export default component.exports